var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('img',{ref:"qrcode"}),_c('v-card-text',[_c('v-text-field',{attrs:{"readonly":_vm.readonly},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }